module.exports = __webpack_public_path__ + "static/delivery-service-25d11a45f658687778a3a83c47aac014.png";